import { render, staticRenderFns } from "./resume.vue?vue&type=template&id=587b78ef"
import script from "./resume.vue?vue&type=script&lang=ts"
export * from "./resume.vue?vue&type=script&lang=ts"
import style0 from "./resume.vue?vue&type=style&index=0&id=587b78ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports